<ng-template #risklineAlertModalForm let-modal>
  <div class="modal-header d-flex align-items-start">
    <div class="flex-grow-1">
      <h5 class="modal-title mb-1">{{ alert.title || 'Loading...' }}</h5>
      <small class="text-muted">{{ getCategoryLabel(alert.categoryID) }}</small>
    </div>
    <span class="ms-2 badge rounded-pill" [ngStyle]="riskBadgeStyle(alert.riskLevelID)">{{ riskLabel(alert.riskLevelID) }}</span>
    <button type="button" class="btn-close ms-2" (click)="cancelForm()" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    @if (isLoading) {
      <app-spinner></app-spinner>
    }

    @if (!isLoading) {
      <p>{{ alert.text }}</p>

      @if (alert.advice) {
        <div class="alert alert-info"><strong>Advice:</strong> {{ alert.advice }}</div>
      }

      <div class="row mt-2">
        <div class="col-md-4"><strong>Start:</strong> {{ alert.startDate }}</div>
        <div class="col-md-4"><strong>End:</strong>   {{ alert.endDate }}</div>
        <div class="col-md-4"><strong>Status:</strong> {{ alert.takesPlace===true ? 'Active' : (alert.takesPlace===false ? 'Past' : '—') }}</div>
      </div>
    }
  </div>

  <div class="px-3 pb-2">
    <app-riskline-attribution [hideCredit]="true"></app-riskline-attribution>
  </div>

  <div class="modal-footer justify-content-between">
    <app-riskline-attribution [hideDisclaimer]="true"></app-riskline-attribution>
    <button type="button" class="btn btn-light" (click)="cancelForm()">Close</button>
  </div>
</ng-template>
